import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-bt gfu-bt--caption _tc--light _mt-0 _ttu" }
const _hoisted_3 = {
  class: "gfu-hd gfu-subscription-management-settings__title",
  "data-qa": "creator-name"
}
const _hoisted_4 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_option_field = _resolveComponent("option-field")
  const _component_subscribed_project_management_settings = _resolveComponent("subscribed-project-management-settings")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", {
    class: "gfu-grid__cell gfu-1of1",
    "data-qa": `creatorID:${$props.creatorID}`
  }, [
    _createVNode(_component_box, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.SubscriptionManagement.CreatorNotificationsSectionHeader), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", { href: $props.creatorUrl }, _toDisplayString($props.creatorName), 9 /* TEXT, PROPS */, _hoisted_4)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.availableOptions, (option) => {
          return (_openBlock(), _createBlock(_component_option_field, {
            key: option.dataQa,
            modelValue: _ctx.model[option.model],
            "onUpdate:modelValue": [$event => ((_ctx.model[option.model]) = $event), option.onInput],
            options: option.options,
            "first-column-width": 8,
            "display-name": option.displayName,
            layout: "columns",
            description: option.description,
            "data-qa": option.dataQa
          }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options", "display-name", "description", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredProjectsWidthDefault, (project) => {
          return (_openBlock(), _createBlock(_component_subscribed_project_management_settings, _mergeProps({
            key: project.projectID
          }, { ref_for: true }, project, {
            onProjectNotificationPreferenceChange: $options.handleEmit,
            "data-qa": `projectID:${project.projectID}`
          }), null, 16 /* FULL_PROPS */, ["onProjectNotificationPreferenceChange", "data-qa"]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _: 1 /* STABLE */
    })
  ], 8 /* PROPS */, _hoisted_1))
}